import { Fastlane } from "@/features/fastlane";
import { useFastlaneInitialFilters } from "@/features/todos/initial-filters";
import type { InvoiceTypeString } from "@/lib/constants/invoice-type";
import { useInvoiceBrowser } from "@/providers/invoice-browser";
import { useInvoicePdfCache } from "@/providers/invoice-pdf-cache";
import { useEffect, useMemo } from "react";

export default function TodosFastlane({ type }: { type: InvoiceTypeString }) {
  const initialColumnFilters = useFastlaneInitialFilters();
  const { setInvoiceBrowsingQueue } = useInvoiceBrowser();
  const { clearCache } = useInvoicePdfCache();

  useEffect(() => {
    return () => {
      clearCache();
    };
  }, []);

  useEffect(() => {
    setInvoiceBrowsingQueue([]);
  }, []);

  return (
    <Fastlane
      tableName="todos.fastlane"
      initialColumnFilters={initialColumnFilters}
      invoiceType={type}
    />
  );
}
